import "./sendQuoteWarning.scss"

export const SendQuoteWarnig = ({ onClose, send }) => {
    const handleSend = ()=>{
        send()
        onClose()
    }
    return (
        <section className="send-quote-warning">
            <nav className="send-quote-warning-nav">
                <h3>Are You Sure You Want To Send This Quote?</h3>
                <button  onClick={onClose}><i className="icon-cross"></i></button>
            </nav>

            <div>
                <p>Once submitted, the information in the quote cannot be edited again. Make sure to carefully review the information entered before continuing.</p>
            </div>
            <section>
                <button onClick={handleSend}>Ok</button>
                <button onClick={onClose}>Cancel</button>
            </section>
        </section>
    )
}
